<template>
	<md-card>
		<md-card-header class="md-card-header-icon md-card-header-blue">
			<div class="md-layout">
				<div class="md-layout-item">
					<div class="card-icon">
						<font-awesome-icon class="md-icon" :icon="['fas', 'clipboard-list']"/>
					</div>
					<h4 class="title">{{ title }}</h4>
				</div>
			</div>
		</md-card-header>
		<md-card-content>
			<md-table class="paginated-table"
				:value="sites"
			>
				<md-table-toolbar>
					<md-field>
						<label for="pages">Éléments à afficher</label>
						<md-select v-model="pagination.perPage" name="pages">
							<md-option
								v-for="item in pagination.perPageOptions"
								:key="item" :label="item" :value="item">
								{{ item }}
							</md-option>
						</md-select>
					</md-field>

					<md-field>
						<md-input
							type="search"
							clearable
							style="width: 250px"
							placeholder="Rechercher..."
							v-model="searchQuery"
						>
						</md-input>
					</md-field>
				</md-table-toolbar>

				<md-table-row slot="md-table-row" slot-scope="{ item }">
					<md-table-cell md-label="Client" style="max-width: 400px; width: 400px;">
						<span class="text-info cursor-pointer" @click="goToRoute('Client Details', item.client_id)">
							{{ item.client_name }}
						</span>
					</md-table-cell>
					<md-table-cell md-label="Site" style="max-width: 400px; width: 400px;">
						<span class="text-info cursor-pointer" @click="goToRoute('Site Details', item.client_id, item.id)">
							{{ item.name }}
						</span>
					</md-table-cell>
					<md-table-cell md-label="Technicien Principal">
						<select v-model="item.tech1">
							<option :value="null"></option>
							<option v-for="technician in technicians" :key="technician.id" :value="technician.id">
								{{ technician.full_name }}
							</option>
						</select>
					</md-table-cell>
					<md-table-cell md-label="Deuxième Technicien">
						<select v-model="item.tech2">
							<option :value="null"></option>
							<option v-for="technician in technicians" :key="technician.id" :value="technician.id">
								{{ technician.full_name }}
							</option>
						</select>
					</md-table-cell>
					<md-table-cell md-label="Troisième Technicien">
						<select v-model="item.tech3">
							<option :value="null"></option>
							<option v-for="technician in technicians" :key="technician.id" :value="technician.id">
								{{ technician.full_name }}
							</option>
						</select>
					</md-table-cell>
					<md-table-cell md-label="">
						<div class="text-center">
							<md-button class="md-icon-button md-raised md-success"
									   @click="updateSite(item)">
								<i class="md-icon fa fa-sync"/>
							</md-button>
							<md-tooltip md-direction="top">Mettre à jour</md-tooltip>
						</div>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</md-card-content>
		<md-card-actions md-alignment="space-between">
			<p class="card-category">
				Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
			</p>
			<pagination
				class="pagination-no-border pagination-info"
				v-model="pagination.currentPage"
				:per-page="pagination.perPage"
				:total="pagination.total"
				@input="getSites"
			>
			</pagination>
		</md-card-actions>
	</md-card>
</template>

<script>
import { Pagination } from "@/components";

export default {
	name: "TechnicianCard",
	components: {
		Pagination
	},
	props: {
		title: String,
		active: Boolean,
		order: Number,
	},
	computed: {
		/***
		 * Returns a page from the searched data or the whole data. Search is performed in the watch section below
		 */
		queriedData() {
			let result = this.sites;
			if (this.searchedData.length > 0) {
				result = this.searchedData;
			}
			return result.slice(this.from, this.to);
		},
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		total() {
			return this.searchedData.length > 0
				? this.searchedData.length
				: this.sites.length;
		},
	},
	data() {
		return {
			sites: [],
			technicians: [],
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [25, 50, 100],
				total: 0
			},
			searchQuery: "",
			propsToSearch: ["name"],
			searchedData: [],
			fuseSearch: null
		}
	},
	methods: {
		async getSites() {
			const response = await this.$store.dispatch('sites/getSitesWithTechnicians', {
				order: this.order,
				page: this.pagination.currentPage,
				perPage: this.pagination.perPage,
				search: this.searchQuery
			})
			this.sites = response.data.data
			this.pagination.total = response.data.total
		},
		async getTechnicians() {
			const { data } = await this.$store.dispatch('users/getTechnicians', { isActive: true })
			this.technicians = data
		},
		async updateSite(site) {
			try {
				await this.$store.dispatch('sites/updateTechnicians', site)
				await this.$store.dispatch('alerts/success', 'Techniciens modifiés')
				await this.getSites()
			} catch (e) {
				await this.$store.dispatch('alerts/error', 'Une erreur est survenue')
			}
		},
		goToRoute(route, id = null, idSite = null) {
			let newRoute
			if(route === 'Site Details') {
				newRoute = this.$router.resolve({ name: route, params: { id, idSite } })
			} else {
				newRoute = this.$router.resolve({ name: route, params: { id } })
			}
			window.open(newRoute.href, '_blank')
		}
	},
	mounted() {
		if(this.active) {
			this.getTechnicians()
			this.getSites()
		}
	},
	watch: {
		active: function(newVal, oldVal) {
			if(newVal) {
				this.getTechnicians()
				this.getSites()
			}
		},
		searchQuery() {
			this.getSites()
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep {
	.md-table-cell-container .md-button {
		width: auto;

		.md-icon {
			font-size: .875rem !important;
			min-width: .875rem !important;
			height: .875rem !important;
		}
	}
}
</style>
